import * as React from "react";
import { cn } from "../../lib/utils.js";

const Input = React.forwardRef(
  ({ className, type = "text", error = false, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      aria-invalid={error || undefined}
      className={cn(
        "flex h-10 w-full rounded-md px-3 py-2 text-sm",
        "bg-surface-1 text-text-primary placeholder:text-text-muted",
        // shadow-well y no shadow-card: un campo de formulario recibe, no
        // sobresale. Hundirlo es el par exacto del relieve del botón, y es lo
        // que distingue "acá se escribe" de "acá se pulsa" antes de leer nada
        // (ver `--shadow-well` en index.css).
        "border shadow-well transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0",
        // border-strong, no border: el input comparte relleno con su contenedor
        // habitual (SlidePanel y Card son surface-1), así que su único límite
        // es el borde. Con `border` daba 1.41:1 — WCAG 1.4.11 exige 3:1 para
        // identificar un control.
        error
          ? "border-danger focus-visible:ring-danger/40"
          : "border-border-strong focus-visible:border-primary focus-visible:ring-primary/40",
        "disabled:cursor-not-allowed disabled:opacity-50",
        type === "search" &&
          "[&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export { Input };
